__turbopack_context__.v({
  "blok-big-title": "ColorPicker-module__t6i45a__blok-big-title",
  "blok-subtitle": "ColorPicker-module__t6i45a__blok-subtitle",
  "blok-title": "ColorPicker-module__t6i45a__blok-title",
  "color": "ColorPicker-module__t6i45a__color",
  "color-info": "ColorPicker-module__t6i45a__color-info",
  "colors": "ColorPicker-module__t6i45a__colors",
  "customContainer": "ColorPicker-module__t6i45a__customContainer",
  "selected": "ColorPicker-module__t6i45a__selected",
  "soldOut": "ColorPicker-module__t6i45a__soldOut",
  "soldOutTag": "ColorPicker-module__t6i45a__soldOutTag",
  "variant-name": "ColorPicker-module__t6i45a__variant-name",
});
